// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19pkxmi2{margin-top:var(--ds-space-negative-150,-9pt)}\n._1bah1yb4{justify-content:space-between}\n._1bsb1ris{width:max-content}\n._1e0c1txw{display:flex}\n._2lx2vrvc{flex-direction:row}\n._ca0qutpp{padding-top:var(--ds-space-150,9pt)}", ""]);
// Exports
module.exports = exports;
